import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from '../../hooks';
import { styled } from '../../utils';
import { Icon } from '../Icon';
import { Typography } from '../Typography';
const getVariant = (variant, palette, textColor, backgroundColor) => {
    switch (variant) {
        case 'black':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.grey[50],
            };
        case 'grey':
            return {
                textColor: palette.groupPrimary.darkBlue,
                backgroundColor: palette.groupPrimary.zurichWhite,
            };
        case 'purple':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.purple.dark,
            };
        case 'green':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.mint[100],
            };
        case 'cyan':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.teal['A100'],
            };
        case 'blue':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.groupPrimary.zurichBlue,
            };
        case 'darkBlue':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.groupPrimary.darkBlue,
            };
        case 'salmon':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.error.main,
            };
        case 'orange':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.groupPrimary.orange100,
            };
        case 'success':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.success.main,
            };
        case 'error':
            return {
                textColor: palette.grey['A100'],
                backgroundColor: palette.error.main,
            };
        default: {
            return {
                textColor: textColor ?? palette.groupPrimary.darkBlue,
                backgroundColor: backgroundColor ?? palette.groupPrimary.zurichWhite,
            };
        }
    }
};
const WrapperDiv = styled('div', {
    shouldForwardProp: (prop) => prop !== 'backgroundColor',
})(({ theme, backgroundColor }) => ({
    display: 'inline-block',
    borderRadius: '6px',
    padding: theme.spacing(0.25, 1),
    backgroundColor,
}));
const TypographyStyled = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'textBold' && prop !== 'textColor' && prop !== 'small',
})(({ textColor, textBold, small }) => ({
    color: textColor,
    fontWeight: textBold ? 'bold' : 'lighter',
    ...(small ? { fontSize: '0.75rem' } : {}),
    display: 'flex',
    alignItems: 'center',
}));
const IconStyled = styled(Icon)(({ theme }) => ({
    marginRight: theme.spacing(1),
}));
const ChildrenSpan = styled('span')({
    display: 'flex',
    alignItems: 'center',
});
export function Tag({ children, variant, textColor, backgroundColor, textBold, icon, variantTypo, small, className, }) {
    const theme = useTheme();
    const { textColor: variantTextColor, backgroundColor: variantBackgroundColor, } = getVariant(variant, theme.palette, textColor, backgroundColor);
    return (_jsx(WrapperDiv, { backgroundColor: variantBackgroundColor, className: className, children: _jsxs(TypographyStyled, { variant: variantTypo || 'button', textBold: textBold, small: small, textColor: variantTextColor || theme.palette.grey['A100'], children: [icon && _jsx(IconStyled, { variant: icon, fontSize: "small" }), _jsx(ChildrenSpan, { children: children })] }) }));
}
